export default class CommunicationErrorEntity {
    errorCode: string;
    errorDescription: string;
    public constructor (errorCode: string,errorDescription: string){
        this.errorCode = errorCode;
        this.errorDescription = errorDescription;
    }
}